import { PricingTableModel } from '@app/models/PricingTableModel';
import axios from 'axios';

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL;

export const getStripePricingTables = async (): Promise<PricingTableModel[]> => {
  if (!API_URL) return;
  return axios.get(`${API_URL}/api/game-dev/pricing-table`).then((res) => res.data);
};
